
const state = {
    value:{},
}

type stateType = typeof state;

const mutations = {
    SET_VAL: (state: any, value: string) => {
        state.value = value
    }
}

const actions = {
    setVal({ commit }: { commit: Function }, val: string) {
        commit('SET_VAL', val)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
